import request from '@/utils/request'

export function getSeasons(data) {
    return request({
        url: '/api/member/race-horse/getRaceSeasonList',
        method: 'post',
        data
    })
}

export function getRaceList(data) {
    const {st, et, data: dataId} = data;
    return request({
        url: `/api/member/race-horse/getRaces?st=${st}&et=${et}`,
        method: 'post',
        data: dataId
    })
}